import { generateSeperatorTags } from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/utils';

export default class DeliveryTimeModel {
  originalData: any = null;
  textName = undefined;
  icon = undefined;
  constructor(data) {
    this.originalData = data;
    this.textName = this.originalData?.deliveryTimeDesc;
    this.icon = this.originalData?.deliveryTimeIconUrl;
  }

  paramsForLxLog = () => ({
    delivery_time: this.originalData?.deliveryTimeDesc || '-999',
  })
}
